import React, { useState, useEffect } from 'react';
import { makeStyles,styled } from "@mui/styles";
import Styles from  './BrokerageCalculator.module.css';
import Fando from "./FandO.js";
import Currency_main from './Currency.js';
// import Commodities from './commodities.js';
import Footer from '../../../Common/Footer.js';
import { Typography, Grid2, Tab, Tabs } from '@mui/material';
import DocumentMeta from 'react-document-meta';
import { useLocation } from 'react-router-dom';
import { motion } from "framer-motion";
import { useLanguage } from '../../../Context/LangContext.js';
// meta tag & content added - 02/09/24 - Dev Srini
const meta = {
    title: 'Low Cost Brokerage | NSE & BSE Trading Calculator | TradeBoss',
    description: 'Use TradeBoss brokerage calculator to estimate low-cost trades on NSE & BSE. Open a demat account and start trading smartly with transparent fees.',
    canonical: 'https://tradeboss.co/tools-calculators/brokerage',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'brokerage calculator India, low brokerage trading fees, NSE brokerage calculator, BSE brokerage fees, calculate brokerage charges, how much brokerage for stock trade, brokerage calculator tool, brokerage cost, compare brokerage rates, Low cost brokerage on NSE, BSE trades, Open a demat account and trade stocks, bonds, and IPOs with competitive fees, Trading Calculator'
        }
    }
};

const StyledTabs = styled(Tab)({
    '&.Mui-selected': {
        fontFamily: 'Inter700 !important',
        color:"#000000 !important",
        textTransform: 'capitalize !important',
        fontSize: 'calc(16px + var(--font-delta))',
    },
});


const Brokerage = () => {
    const [tabValue, setTabValue] = useState(0);
    const location = useLocation();
      const MotionGrid = motion(Grid2);
    const { language } = useLanguage();
    const handleTabChange = (event, value) => {
        console.log('tabvalue==', value);
        setTabValue(value);
    };


    const heading = {
        en: "Brokerage calculator",
        hi: "ब्रोकरेज कैलकुलेटर",
        kn: "ಬ್ರೋಕರೇಜ್ ಕ್ಯಾಲ್ಕ್ಯುಲೇಟರ್",
        ma: "ब्रोकरेज कॅल्क्युलेटर",
        gu: "બ્રોકરેજ કેલ્ક્યુલેટર"
    };

    const equitiesFO={
        en: "Equities - F&O",
        hi: "इक्विटीज़ - F&O",
        kn: "ಈಕ್ವಿಟೀಸ್ - F&O",
        ma: "इक्विटीज - F&O",
        gu: "ઇક્વિટીઝ - F&O"
    }

    const currency = {
        en: "Currency",
        hi: "मुद्रा",
        kn: "ಕರೆನ್ಸಿ",
        ma: "चलन",
        gu: "ચલણ"
    }
    useEffect(() => {
        document.body.style.backgroundColor = "#F7F9FA";
        // const queryParams = new URLSearchParams(location.search);
        // const id = queryParams.get('type');
        setTabValue(0)
        window.scrollTo(0, 0)
    }, [location.search]);

    return (
        <div>
            <DocumentMeta {...meta} />
            <Grid2 className={Styles.maincard}
               >
                <h1 className={Styles.bmaintit}> {heading[language] || heading.en}</h1>
            </Grid2>


            <Grid2 style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Grid2 style={{ width: '90%' }}>
                    <Grid2 >


                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        style={{ background: '#F7F9FA' }}
                        indicatorColor='red'
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#F3D45E"
                            }
                        }}
                    >
                            <StyledTabs style={{ width: '33%' }} sx={{
                                fontFamily: tabValue === 0 ? "Inter700" : "Inter400",
                                fontWeight: tabValue === 0 ? 700 : 400,
                                fontSize: "calc(16px + var(--font-delta))",
                                textTransform: "capitalize",
                                color: "#000",
                            }} label={equitiesFO[language] || equitiesFO.en}
                                />
                            <StyledTabs style={{ width: '33%' }} sx={{
                                fontFamily: tabValue === 1 ? "Inter700" : "Inter400",
                                fontWeight: tabValue === 1 ? 700 : 400,
                                fontSize: "calc(16px + var(--font-delta))",
                                textTransform: "capitalize",
                                color: "#000",
                            }} label={currency[language] || currency.en}
                               />
                    </Tabs>
                    </Grid2>
                    {tabValue === 0 && (
                        <main style={{ background: '#F7F9FA', height: 'auto', width: '100%', marginTop: '25px' }}
                           >

                            <Fando />

                        </main>
                    )}

                    {tabValue === 1 && (
                        <Grid2 style={{ background: '#F7F9FA', height: 'auto', width: '100%', marginTop: '25px' }}
                         >
                           <Currency_main />
                        </Grid2>
                    )}


                </Grid2>
            </Grid2>
            <Grid2 style={{ width: '100%' }}>
                <Footer />
            </Grid2>
        </div>
    );
};

export default Brokerage;
